import React, { useEffect, useState } from "react";
import { api } from "../../config/api";
import { BackEndRoutes } from "../../config/back-end-routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill1 } from "@fortawesome/free-solid-svg-icons";

interface Props {
  data: any;
  setData: (data: any) => void;
}

const PrazoPagamento: React.FC<Props> = ({ data, setData }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [payment, setPayment] = useState<any[]>([]);

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { id, value } = event.target;
    setData((prevForm: any) => ({
      ...prevForm,
      [id]: value,
    }));
  };

  const getData = () => {
    setLoading(true);
  
    api.get(BackEndRoutes.routes.PRAZOS_PAGAMENTOS.LIST)
      .then((response: any) => {
        if (response.data) {
          setPayment(response.data);
        }
      })
      .catch((error: any) => {
        console.error("Erro ao buscar prazos de pagamento:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };  

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center gap-2 justify-content-start">
        <FontAwesomeIcon icon={faMoneyBill1} className="fa-xl mb-1" />
        <h4>Informações sobre o Prazo de Pagamento</h4>
      </div>
      <p className="mt-1">Adicionar Prazo de Pagamento</p>
      {loading ? (
        <p>Carregando...</p>
      ) : (
        <select
          id="prazo_pagto"
          className="form-control"
          value={data.prazo_pagto || ""}
          onChange={handleChange}
        >
          {payment
            .filter((term) => term.status === 1)
            .map((term) => (
              <option key={term.id_prazo} value={term.id_prazo}>
                {term.descricao}
              </option>
            ))}
        </select>
      )}
    </div>
  );
};

export default PrazoPagamento;
